export const msalConfig = {
    authority: 'https://login.microsoftonline.com/61fd1d36-fecb-47ca-b7d7-d0df0370a198',
    clientId: 'eb0a608e-a09f-4917-88fa-1c65ecd57462',
    redirectUri: document.getElementById('root').baseURI
};